import api from './api-config';
import { DoctorsDTO } from '../models/Doctors';

export const doctorsService = {
  getAllDoctors: async (params: {
    page?: number;
    size?: number;
    sort?: string[];
    'id.greaterThan'?: number;
    'id.lessThan'?: number;
    'id.equals'?: number;
    'specialty.contains'?: string;
    'specialty.equals'?: string;
    'anonymizedId.equals'?: string;
    'userId.equals'?: string;
    distinct?: boolean;
  } = {}) => {
    const response = await api.get<DoctorsDTO[]>('/doctors', { 
      params: { 
        ...params,
        sort: params.sort?.join(',')
      } 
    });
    return response.data;
  },

  getDoctor: async (id: number) => {
    const response = await api.get<DoctorsDTO>(`/doctors/${id}`);
    return response.data;
  },

  createDoctor: async (doctorData: DoctorsDTO) => {
    const response = await api.post<DoctorsDTO>('/doctors', doctorData);
    return response.data;
  },

  updateDoctor: async (id: number, doctorData: DoctorsDTO) => {
    const response = await api.put<DoctorsDTO>(`/doctors/${id}`, doctorData);
    return response.data;
  },

  deleteDoctor: async (id: number) => {
    await api.delete(`/doctors/${id}`);
  },

  partialUpdateDoctor: async (id: number, doctorData: Partial<DoctorsDTO>) => {
    const response = await api.patch<DoctorsDTO>(`/doctors/${id}`, doctorData);
    return response.data;
  },

  countDoctors: async (params: {
    'id.greaterThan'?: number;
    'id.lessThan'?: number;
    'id.equals'?: number;
    'specialty.contains'?: string;
    'specialty.equals'?: string;
    'anonymizedId.equals'?: string;
    'userId.equals'?: string;
    distinct?: boolean;
  } = {}) => {
    const response = await api.get<number>('/doctors/count', { params });
    return response.data;
  },

  getLoggedDoctor: async () => {
    const response = await api.get<DoctorsDTO>('/doctors/loggedDoctor');
    return response.data;
  }
};